const messages = [
    {
        "name": "MSG0",
        "type": 17,
        "id": "9iWDgzvNe1gcviF1TU7Jvn"
    }
]

export default messages